import { render, staticRenderFns } from "./rateConfiguration.vue?vue&type=template&id=23602f0c&scoped=true&"
import script from "./rateConfiguration.vue?vue&type=script&lang=js&"
export * from "./rateConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./rateConfiguration.vue?vue&type=style&index=0&id=23602f0c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23602f0c",
  null
  
)

export default component.exports